// extracted by mini-css-extract-plugin
export default {"list":"item-list_list__ryUGb","item":"item-list_item__X76x2","item--selected":"item-list_item--selected__ohPp7","item__title":"item-list_item__title__eAh5y"};